export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10549.69844df0.jpg";